













































































































import Vue from 'vue';
import { Machine, interpret } from 'xstate';
import { setTimeout } from 'timers';

enum Events {
  CANCEL = 'CANCEL',
  EDIT = 'EDIT',
  UPDATE = 'UPDATE',
}

type Context = {};

type StateSchema = {
  states: {
    display: {};
    edit: {};
    updating: {};
    error: {};
  };
};

type Event =
  | { type: 'EDIT' }
  | { type: 'CANCEL' }
  | { type: 'UPDATE' }
  | { type: 'UPDATED' }
  | { type: 'ERROR' };

const machine = Machine<Context, StateSchema, Event>({
  id: 'price',
  initial: 'display',
  states: {
    display: {
      on: { EDIT: 'edit' },
    },
    edit: {
      on: {
        CANCEL: {
          target: 'display',
          actions: ['resetValue'],
        },
        UPDATE: {
          target: 'updating',
        },
      },
    },
    updating: {
      onEntry: ['update'],
      on: {
        UPDATED: 'display',
        ERROR: 'error',
      },
    },
    error: {
      on: {
        CANCEL: {
          target: 'display',
          actions: ['resetValue'],
        },
        UPDATE: {
          target: 'updating',
        },
      },
    },
  },
});

type UpdateFunc = (id: string, price: number) => Promise<object | null>;

export default Vue.extend({
  props: {
    id: {
      type: String as () => string,
      required: true,
    },
    containerClass: {
      type: String as () => string,
    },
    currency: {
      type: String as () => string,
      required: true,
    },
    displayAsLabel: {
      type: Boolean as () => boolean,
      default: false,
    },
    inputClass: {
      type: String as () => string,
    },
    price: {
      type: String as () => string,
      required: true,
    },
    size: {
      type: String as () => 'large' | 'default' | 'small',
      default: 'default',
    },
    updateFunc: {
      type: Function,
    },
  },

  data() {
    return {
      fsm: interpret(machine, { execute: false }),
      isBusy: false,
      isEdit: false,
      isError: false,
      value: this.price,
    };
  },

  created() {
    this.fsm
      .onTransition((state, event) => {
        const [current] = state.toStrings();
        switch (current) {
          case 'display':
            this.isBusy = false;
            this.isEdit = false;
            this.isError = false;
            break;
          case 'edit':
            this.isBusy = false;
            this.isEdit = true;
            this.isError = false;
            break;
          case 'updating':
            this.isBusy = true;
            this.isEdit = true;
            this.isError = false;
            break;
          case 'error':
            this.isBusy = false;
            this.isEdit = true;
            this.isError = true;
            break;
          default:
        }

        // run actions via methods
        const { actions } = state;

        // @ts-ignore Index signature issue due to calling function by function name
        actions.forEach((action) => this[action.type](event));
      })
      .start();
  },

  beforeDestroy() {
    this.fsm.stop();
  },

  methods: {
    cancel() {
      this.fsm.send({ type: 'CANCEL' });
    },

    edit() {
      this.fsm.send({ type: 'EDIT' });
    },

    resetValue() {
      this.value = this.price;
    },

    startUpdate() {
      this.fsm.send({ type: 'UPDATE' });
    },

    async update() {
      const f = this.updateFunc as UpdateFunc;
      try {
        const result = await f(this.id, parseFloat(this.value));
        if (!result) {
          this.fsm.send('ERROR');
        } else {
          this.fsm.send('UPDATED');
        }
      } catch (err) {
        this.fsm.send('ERROR');
      }
    },
  },
});
